enum PurchaseTypeGroup {
    NotSet = 0,
    Finance = 1,
    Outright = 2,
    Lease = 3
}
export default PurchaseTypeGroup;
